/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, mergeMap } from 'rxjs';
import { SecureStorageService } from '../services/secure-storage.service';
import { environment } from '../enviroments/enviroment';
import { SessionService } from '../services/session.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private publicEndpoints = [
    'prestamos-calculos',
    'formularios/estados-civiles',
    'formularios/provincias',
    'formularios/empleos',
    'formularios/motivos-prestamos',
    'existe-cliente',
    'login',
    'registro',
    'verification-code/create',
    'code-signin',
    'parametria',
    'validate-captcha',
    'report',
  ].map((item) => `${environment.apiUrl}/${item}`);

  constructor(private secureStorage: SecureStorageService, private sessionService: SessionService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const key = this.publicEndpoints.includes(req.url) ? environment.getTokenKey : environment.loggedTokenKey;
    const sessionData = this.sessionService.sessionData();
    let newReq = req.clone();
    if (sessionData && sessionData.uuid) newReq = newReq.clone({ setHeaders: { 'X-User-Session': sessionData.uuid } });
    return from(this.secureStorage.retrieveDecrypted(key)).pipe(
      mergeMap((token) => {
        if (token)
          newReq = newReq.clone({
            setHeaders: { Authorization: `Bearer ${token}` },
          });

        return next.handle(newReq);
      }),
    );
  }
}
